export default "__VITE_ASSET__CtRwteLc__"